module.exports = {
  language: '语言',
  selectLanguage: '请选择语言',
  charging: '充电中',
  notCharging: '已接通电源',
  advanceSetting: '高级设置',
  chargingDesc: '电量低于指定值时启动充电',
  enabled: '开启',
  disabled: '关闭',
  onPowerRestore: '来电开机',
  powerWakeDesc: '** 请使用两个独立的USB充电器分别为树莓派和PiSugar充电，并保持PiSugar的电源开关在打开状态，这样在外部电源恢复的时候会自动开机。',
  powerWakeDescFor3: 'PiSugar在外部电源恢复的时候会自动开机。',
  powerWakeOffWarning: '您已关闭来电开机功能，请不要单独给树莓派外接电源。',
  powerWakeOffTitle: '提示',
  confirmButtonText: '确认',
  wakeUpFeature: '自动开机',
  repeat: '重复',
  repeatEveryday: '每天重复。',
  repeatOn: '',
  checkAll: '全选',
  clearAll: '清空选项',
  wakeUpDesc: '定时开机时间已设定为',
  wakeUpOffDesc: '定时开机功能已关闭。',
  buttonFunction: '自定义按钮功能',
  singleTapLabel: '单击',
  doubleTapLabel: '双击',
  longTapLabel: '长按',
  singleTap: '单击',
  doubleTap: '双击',
  longTap: '长按',
  none: '无',
  edit: '编辑',
  customShell: '自定义Shell',
  shutdown: '关机',
  shellModalTitle: {
    single: '单击时触发的shell',
    double: '双击时触发的shell',
    long: '长按时触发的shell'
  },
  shell: 'Shell',
  shellPlaceholder: '请输入要执行的shell...',
  cancel: '取消',
  confirm: '确认',
  triggered: '触发',
  safeShutdown: '低电量关机',
  batteryLevel: '电量',
  immediately: '立即执行',
  secondsDelay: '秒后执行',
  rtcTime: 'RTC时间',
  sysTime: 'SYS时间',
  syncTime: '同步时间',
  weekDay: {
    Monday: '周一',
    Tuesday: '周二',
    Wednesday: '周三',
    Thursday: '周四',
    Friday: '周五',
    Saturday: '周六',
    Sunday: '周日'
  },
  weekDayShort: {
    Mon: '周一',
    Tue: '周二',
    Wed: '周三',
    Thu: '周四',
    Fri: '周五',
    Sat: '周六',
    Sun: '周日'
  },
  batteryInputProtect: '充电保护',
  batteryInputProtectDesc: '充电过程将会在60%～80%电量时停止，将有效延长电池寿命。',
  antiMistouch: '防误触',
  antiMistouchDesc: '防误触开启后，开关需要单击+长按方式才能触发。',
  softPoweroff: '软关机',
  softPoweroffDesc: '使用开关按键关机将不会直接断电，而是由软件发出关机指令。',
  softPoweroffShell: '软关机Shell',
  softPoweroffShellDesc: '在软关机事件被触发时执行的shell指令。',
  changeLoginPassword: '修改登录密码',
  username: '用户名',
  password: '密码',
  passwordConfirm: '请再次输入密码',
  usernameCannotBeEmpty: '用户名不能为空',
  passwordCannotBeEmpty: '密码不能为空',
  passwordNotConsistent: '两次输入的密码必须一致',
  usernameWithSpace: '用户名不能包含空格',
  passwordWithSpace: '密码不能包含空格',
  changePasswordSuccess: '修改完成',
  loginDialog: '登录',
  login: '登录'
}



// WEBPACK FOOTER //
// ./src/locale/zh-CN.js